import React from "react";
import { Switch } from "react-router-dom";
import AuthRoute from "./AuthRoute";
import RecruiterCandidates from "../../../pages/recruiter/Candidates";

import Search from "../../../pages/recruiter/Search";
import Dashboard from "../../../pages/dashboard";
import ParsedResume from "../../Candidates/ParsedResume";
import Singlechat from "../../../pages/chat/Singlechat";
import EmployeeDashboard from "../../../pages/dashboard/dashboardItems/EmployeeDashboard";
import { Route } from "react-router-dom";
import ApplyLeave from "../../../pages/employee/attendance/ApplyLeave";
import MyOpinions from "../../../pages/employee/opinions/MyOpinions";
import MyFeedback from "../../../pages/employee/opinions/MyFeedback";
import MyConcern from "../../../pages/employee/opinions/MyConcern";
import ApplyPermission from "../../../pages/employee/attendance/ApplyPermission";
import CalendarUI from "../../../pages/employee/calender/CalendarUI";
import MyAppreciation from "../../../pages/employee/certificates/MyAppreciation";
import ProjectDetails from "../../../pages/employee/projectDetails/ProjectDetails";
import Profile from "../../../pages/employee/UserDetails/UserDetails";
import EmployeeUserInfo from "../../../pages/employee/UserDetails/EmployeeUserInfo";
import EmployersCertificate from "../../../pages/employee/ViewEmployeeCertificate/EmployersCertificate";
import ViewAttendanceDetails from "../../../pages/employee/attendance/ViewAttendanceDetails";
import ViewJobposting from "../../../pages/employee/internalJobposting/ViewJobposting";
import SeparationTemplate from "../../../pages/employee/separation/SeparationTemplate";
import PolicyHandBook from "../../../pages/employee/PolicyHandbook/PolicyHandBook";
import { EmployeeDataProvider } from "../../../context/EmployeeDataContext";
import ViewMyPaySlip from "../../../pages/employee/payslip/ViewMyPaySlip";
import EmployeeTaxDocument from "../../../pages/employee/TaxDocument/EmployeeTaxDocument";
import EmployeeAssetManagement from "../../../pages/employee/assetManagement/EmployeeAssetManagement";
import ViewLoan from "../../../pages/employee/loanManagement/ViewLoan";

const EmployeeRoutes = ({ role }) => {
  return (
    <Switch>
      {/* <AuthRoute path="/app/search" role={role} roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR"]} component={Search} />
            <AuthRoute path="/app/dashboard" role={role} roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR"]} component={EmployeeDashboard} />
            <AuthRoute path="/app/singlechat" role={role} roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR",]} component={Singlechat} />
            <AuthRoute path="/app/parsed_resume" role={role} roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR"]} component={ParsedResume} /> */}

      <Route
        path="/app/dashboard"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={EmployeeDashboard}
      />
      <Route
        path="/app/separation"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={SeparationTemplate}
      />

      <Route path="/app/opinions">
        <AuthRoute
          path=""
          role={role}
          roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
          component={MyOpinions}
        />
        <AuthRoute
          path="/app/opinions/feedback"
          role={role}
          roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
          component={MyFeedback}
        />
        <AuthRoute
          path="/app/opinions/concern"
          role={role}
          roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
          component={MyConcern}
        />
      </Route>

      <AuthRoute
        path="/app/apply-leave"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ApplyLeave}
      />
      <AuthRoute
        path="/app/apply-permission"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ApplyPermission}
      />
      <AuthRoute
        path="/app/calendar"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={CalendarUI}
      />
      <Route
        path="/app/payslip"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ViewMyPaySlip}
      />
      <Route
        path="/app/appreciations"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={MyAppreciation}
      />
      <Route
        path="/app/project-details"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ProjectDetails}
      />
      <Route
        path="/app/profile"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={Profile}
      />
      <Route
        path="/app/emp-info"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={EmployeeUserInfo}
      />

      <Route
        path="/app/my-appreciations"
        role={role}
        roles={["EMPLOYEE"]}
        component={EmployersCertificate}
      />
      <Route
        path="/app/attendance"
        role={role}
        roles={["EMPLOYEE"]}
        component={ViewAttendanceDetails}
      />
      <Route
        path="/app/jobpostings"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ViewJobposting}
      />
      <Route
        path="/app/policy-handbook"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={PolicyHandBook}
      />
      <Route
        path="/app/tax-document"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={EmployeeTaxDocument}
      />
      <Route
        path="/app/company-assets"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={EmployeeAssetManagement}
      />
      <Route
        path="/app/view-loan"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ViewLoan}
      />
      {/* <AuthRoute path="/app/recruiter_candidates" role={role} roles={["RECRUITER"]} component={RecruiterCandidates} />
            <AuthRoute path="/app/recruiter_candidates_new" role={role} roles={["RECRUITER"]} component={RECNew} />
            <AuthRoute path="/app/recruiter_candidates_stc" role={role} roles={["RECRUITER"]} component={RECSTC} />
            <AuthRoute path="/app/recruiter_candidates_schedule_interview" role={role} roles={["RECRUITER"]} component={RECScheduleInterview} />
            <AuthRoute path="/app/recruiter_candidates_interview_scheduled" role={role} roles={["RECRUITER"]} component={RECInterviewScheduled} />
            <AuthRoute path="/app/recruiter_candidates_fis" role={role} roles={["RECRUITER"]} component={RECFinalInterviewScheduled} />
            <AuthRoute path="/app/recruiter_candidates_fic" role={role} roles={["RECRUITER"]} component={RECFinalInterviewCompleted} />
            <AuthRoute path="/app/recruiter_candidates_document_collected" role={role} roles={["RECRUITER"]} component={RECDocumentColleted} />
            <AuthRoute path="/app/recruiter_candidates_salary_breakup_shared" role={role} roles={["RECRUITER"]} component={RECSalaryBreakup} />
            <AuthRoute path="/app/recruiter_candidates_offered" role={role} roles={["RECRUITER"]} component={RECOffered} />
            <AuthRoute path="/app/recruiter_candidates_joined" role={role} roles={["RECRUITER"]} component={RECJoined} />
            <AuthRoute path="/app/recruiter_candidates_offer_declined" role={role} roles={["RECRUITER"]} component={RECOfferedDeclined} />
            <AuthRoute path="/app/recruiter_candidates_yet_to_join" role={role} roles={["RECRUITER"]} component={RECYetToJoin} /> */}

      {/* Add more routes specific to RECRUITER here */}
    </Switch>
  );
};

export default EmployeeRoutes;
